<style>
	nav {
		display: none;
	}
</style>

<script lang="ts">
	import Card, { Content, Actions } from '@smui/card';
	import Input from '@smui/textfield';
	import Button, { Label } from '@smui/button';
	import { Icon as CommonIcon } from '@smui/common';
	import { createForm } from 'svelte-forms-lib';
	import * as yup from 'yup';
	import { signin, userSession, redirect } from '../../shared/stores';
	import { success, warning, failure } from '../..//shared/components/common/Toast/Toast';
	import Title from '../..//shared/components/common/Title.svelte';

	let loading = false;
	let responseStatus = null;
	let provider = 'bo';
	let rememberMe = false;

	const { form, errors, state, handleChange, handleSubmit } = createForm({
		initialValues: {
			email: '',
			password: '',
		},
		validationSchema: yup.object().shape({
			email: yup.string().required(),
			password: yup.string().required(),
		}),
		onSubmit: (values) => {
			login(values);
		},
	});

	function login(values) {
		try {
			loading = true;
			responseStatus = null;

			fetch('/api/authentication/login', {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					provider: provider,
					userName: values.email,
					password: values.password,
					rememberMe: false,
				}),
			})
				.then(function (res) {
					res.json().then(function (data) {
						if (data.userName) {
							signin(data);
							redirect('/');
						} else {
							failure('<strong> Error! </strong> <br/> Authentication failed');
						}
					});
				})
				.catch(function () {
					failure('<strong> Error! </strong> <br/> Authentication failed');
				});
			loading = false;
		} catch (e) {
			responseStatus = e.responseStatus || e;
			loading = false;
		}
	}
</script>

{#if !$userSession}
	<Card class="centralize h-[448px] px-8 pt-8 pb-10 sm:w-[600px]" padded>
		<form on:submit="{handleSubmit}">
			<Content>
				<Title title="{'Login'}" />
				<div class="p-4">
					<div>
						<Input bind:value="{$form.email}" on:change="{handleChange}" on:blur="{handleChange}" type="text" class="w-full">
							<svelte:fragment slot="label">
								<CommonIcon class="material-icons-outlined" style="font-size: 1em; line-height: normal; vertical-align: top;"
									>people</CommonIcon
								>
								User name
							</svelte:fragment>
						</Input>
						{#if $errors.email}
							<span class="required">You must enter a user name.</span>
						{/if}
					</div>
					<br />
					<div>
						<Input bind:value="{$form.password}" on:change="{handleChange}" on:blur="{handleChange}" type="password" class="w-full">
							<svelte:fragment slot="label">
								<CommonIcon class="material-icons-outlined" style="font-size: 1em; line-height: normal; vertical-align: top;"
									>lock</CommonIcon
								>
								Password
							</svelte:fragment>
						</Input>
						{#if $errors.password}
							<span class="required">You must enter a password.</span>
						{/if}
						<br />
						<a
							href="/#/recoverypassword"
							class="text-mobilityPlatform-green hover:text-mobilityPlatform-green-hover active:text-mobilityPlatform-green-active text-sm"
							>Forgot your password?</a
						>
					</div>
				</div>
			</Content>
			<Actions class="justify-center">
				<Button type="submit" variant="raised" class="w-[250px]">
					<Label>LOGIN</Label>
				</Button>
			</Actions>
		</form>
	</Card>
{/if}
